import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class HttpclienterrorService {
  /** Guardamos uma ref estática ao TranslateService para poder usar em métodos estáticos */
  private static t: TranslateService | null = null;

  constructor(translate: TranslateService) {
    HttpclienterrorService.t = translate;
  }

  /** Helper para traduzir com fallback seguro (se t ainda não estiver pronto) */
  private static tr(key: string, params?: any): string {
    if (HttpclienterrorService.t) {
      try {
        return HttpclienterrorService.t.instant(key, params);
      } catch {
        /* noop */
      }
    }
    return key; // fallback: devolve chave
  }

  /** Opcional: se precisares só da CHAVE em vez da mensagem traduzida */
  static getServerErrorKey(error: HttpErrorResponse): string {
    switch (error.status) {
      case 0:
        return 'ERRORS.OFFLINE';
      case 400:
        return 'ERRORS.UNEXPECTED'; // se quiseres algo mais específico, cria ERRORS.BAD_REQUEST
      case 401:
        return 'ERRORS.UNAUTHORIZED';
      case 403:
        return 'ERRORS.FORBIDDEN';
      case 404:
        return 'ERRORS.NOT_FOUND';
      case 408:
        return 'ERRORS.TIMEOUT';
      case 413:
        return 'ERRORS.PAYLOAD_TOO_LARGE';
      case 500:
        return 'ERRORS.UNEXPECTED';
      case 503:
        return 'ERRORS.UNEXPECTED';
      default:
        return 'ERRORS.UNEXPECTED';
    }
  }

  /** A tua API pública atual — agora devolve a mensagem já traduzida */
  static getServerErrorMessage(error: HttpErrorResponse): string {
    // 1) Mensagem “curada” vinda do servidor tem prioridade
    const rawBody = (error as any)?.error;
    const userMsg = rawBody?.userMessage;
    const hasError = rawBody?.hasError;
    const msg = rawBody?.message;
    const success = rawBody?.success;

    if (typeof userMsg === 'string' && userMsg.trim()) {
      return userMsg.trim(); // já pode vir no idioma pretendido
    }

    if ((hasError || success === false) && typeof msg === 'string' && msg.trim()) {
      return msg.trim();
    }

    if (typeof msg === 'string' && msg.trim()) {
      return msg.trim();
    }

    if (typeof rawBody === 'string' && rawBody.trim() && !rawBody.trim().startsWith('<')) {
      return rawBody.trim();
    }

    // 2) Mapeamento por status -> chave i18n (as TUAS chaves)
    let key = HttpclienterrorService.getServerErrorKey(error);

    // 3) Alguns estados podem levar params
    const params: any = {};
    if (key === 'ERRORS.UNAUTHORIZED') {
      // Forçamos uma string vazia ou simples para evitar passar objetos JSON para a tradução
      params.msg = '';
    }

    // 4) Tradução com fallback
    const translated = HttpclienterrorService.tr(key, params);

    // 5) Caso raro: conteúdo estranho/circular no body  apenas log
    try {
      JSON.stringify((error as any)?.error);
    } catch (e) {
      console.warn('Erro ao serializar o body do erro:', e);
    }

    console.error(`[Erro ${error.status}]: ${translated}`, error);
    return translated;
  }
}
